import { useState, useEffect } from 'react';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import InputLabel from '../Inputs/InputLabel';

type TableDataProps = {
    columns: GridColDef[],
    rows: any[],
    height?: number,
    handleClick?: (row: any, event?: any | undefined) => void,
    filter?: string,
    title?: string,
    filterOut?: (search: string) => Promise<never[]>
}

type EnhancedTableToolbarProps = {
    rows: any[],
    setRows: any,
    column: string,
    title?: string,
    filterOut?: (search: string) => Promise<never[]>
};

function EnhancedTableToolbar({ rows, setRows, column, title, filterOut }: EnhancedTableToolbarProps) {
    const [filter, setFilter] = useState("");

    async function handleFilter() {
        if (filter.length > 0) {
            if(filterOut){
                const filterRows = await filterOut(filter.toUpperCase());
                setRows(filterRows);
            }else{
                const filterRows = rows.filter((i: any) => String(i[column]).includes(filter.toUpperCase()));
                setRows(filterRows);
            }
        } else {
            setRows(rows);
        }
    }

    return (
        <Toolbar
            sx={[
                {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                }
            ]}
        >
            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h5"
                id="tableTitle"
                component="div"
            >
                <DriveFileMoveIcon /> &nbsp;
                {title}
            </Typography>
            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            />

            <Tooltip title="Filter list">
                <>
                    <IconButton>
                        <FilterListIcon />
                    </IconButton>
                    <InputLabel
                        placeholder='Filtrar'
                        value={filter}
                        setState={setFilter}
                        isUpper
                        onKeyUp={e => {
                            if (e.key === 'Enter') handleFilter();
                        }}
                    />
                </>
            </Tooltip>
        </Toolbar>
    );
}

export default function TableData({ columns, rows, height = 400, handleClick, filter, title, filterOut }: TableDataProps) {
    const paginationModel = { page: 0, pageSize: 100 };
    const [allRows, setAllRows] = useState<any[]>([]);

    useEffect(() => {
        setAllRows(rows);
    }, [rows]);

    return (
        <Paper>
            {filter && (
                <EnhancedTableToolbar 
                    rows={rows} 
                    setRows={setAllRows} 
                    column={filter} 
                    title={title} 
                    filterOut={filterOut}
                />
            )}
            <Paper sx={{ height, width: '82vw' }}>
                <DataGrid
                    rows={allRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[]}
                    sx={{ border: 0 }}
                    density='compact'
                    disableColumnMenu={true}
                    onCellClick={(parms: GridCellParams, event) => {
                        if (handleClick) handleClick(parms.row, event);
                    }}
                    // onRowSelectionModelChange={(row) => {
                    //     console.log(row);
                    // }}
                    localeText={{
                        MuiTablePagination: {
                            labelDisplayedRows: ({ from, to, count }) => `${from}–${to} de ${count}`,
                        },
                        footerRowSelected: () => ``
                    }}
                />
            </Paper>
        </Paper>
    );
}
